export default __webpack_public_path__ + "static/media/Inactive-facility-icon-new.9890042f.svg";